
export default {
    isLogged: false,
    userToken: "",
    userIsAdmin: "user",
    userEmail: "",
    userLastName: "",
    userFirstName: ""
}